import { render, staticRenderFns } from "./CBoxTable.vue?vue&type=template&id=26150733&scoped=true&"
import script from "./CBoxTable.vue?vue&type=script&lang=js&"
export * from "./CBoxTable.vue?vue&type=script&lang=js&"
import style0 from "./CBoxTable.vue?vue&type=style&index=0&id=26150733&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26150733",
  null
  
)

export default component.exports